export default "__VITE_ASSET__inz4wzJr__"